import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';


@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss']
})
export class ReportDetailsComponent implements OnInit {
  pageTitle: any;
  uniqueId: string;
  questionId: number;
  loadingDetails: boolean;
  isLoading: boolean;
  receivers: number;
  questionTitle: string;
  accepted: any  = [];
  acceptedNumber: number;
  denied: any = [];
  deniedNumber: number;
  noResponse: any = [];
  noResponseNumber: number;
  chartResults: any;
  formTitle = '';
  allParents = [];
  currentForm: any;
  report: any;

  constructor(private commonService: CommonService, private route: ActivatedRoute, public toastMessagesService: ToastMessagesService) {
    this.loadingDetails = true;
    this.isLoading = false;
    this.receivers = 0;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      // this.uniqueId = params.id;
      // this.questionId = params.question;

      this.loadingDetails = false;
      this.report = JSON.parse(localStorage.getItem('latestReport'));
      console.log(this.report);

      this.pageTitle = `Λεπτομέρειες αναφοράς`;
      this.formTitle = this.report.formTitle;
      this.questionTitle = this.report.title ? this.report.title : this.report.activityDescription;
      this.receivers = this.report.sum;
      this.acceptedNumber = this.report.accepted;
      this.deniedNumber = this.report.declined;
      this.noResponseNumber = this.report.notAnswered;
      this.chartResults = [this.acceptedNumber, this.deniedNumber, this.noResponseNumber];

      // const details = await this.getDetails();

      // if (details) {
      //   this.pageTitle = `Λεπτομέρειες αναφοράς`;
      //   this.formTitle = details[0].title;
      //   this.questionTitle = details[0].question_title;
      //   const parents = this.countUnique(details);
      //   this.receivers = details.length;
      //   const acceptedparents = this.acceptedParents(details);
      //   const deniedparents = this.deniedParents(details);
      //   const nonresponseparents = this.noResponseParents(details);
      //   this.acceptedNumber = acceptedparents.length;
      //   this.deniedNumber = deniedparents.length;
      //   this.noResponseNumber = nonresponseparents.length;
      //   this.chartResults = [this.acceptedNumber, this.deniedNumber, this.noResponseNumber];
      //   this.accepted = acceptedparents;
      //   this.denied = deniedparents;
      //   this.noResponse = nonresponseparents;
      //   this.allParents = this.accepted.concat(this.denied).concat(this.noResponse);
      // }

      // await this.initForm();
      this.stopLoading();
    });
  }

  async initForm() {
    try {
      const formRequest = await this.commonService.getList(`forms/form?uniqueId=${this.uniqueId}`);
      this.currentForm = formRequest.object[0];
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async getDetails() {
    this.startLoading();
    try {
      const result = await this.commonService.getList(`reports/details?unique_id=${this.uniqueId}&question_id=${this.questionId}`);
      return result.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
      return null;
    }
  }

  //#region Loader
  startLoading() {
    this.isLoading = true;
  }

  stopLoading() {
    this.isLoading = false;
  }

  //#endregion



  countUnique(details) {
    const parents = [];

    for (const detail of details) {
      const index = parents.findIndex(parent => parent.parentId === detail.parent_id);
      if (index === -1) {
        // tslint:disable-next-line:max-line-length
        parents.push({
          parentId: detail.parent_id,
          parentFirstName: detail.parent_first_name,
          parentLastName: detail.parent_last_name,
          email: detail.email
        });
      }
    }

    return parents;
  }

  acceptedParents(details) {
    const parents = [];

    for (const detail of details) {
      if (detail.question_value === 1) {
        // tslint:disable-next-line:max-line-length
        parents.push({
          parentId: detail.parent_id,
          parentFirstName: detail.parent_first_name,
          parentLastName: detail.parent_last_name,
          email: detail.email,
          childName: detail.child_name,
          childLastName: detail.child_last_name,
          consentDate: detail.consent_date,
          questionValue: detail.question_value,
          provider: detail.provider,
          childClass: detail.class_name,
        });
      }
    }
    return parents;
  }

  deniedParents(details) {
    const parents = [];

    for (const detail of details) {
      if (detail.question_value === 0) {
        // tslint:disable-next-line:max-line-length
        parents.push({
          parentId: detail.parent_id,
          parentFirstName: detail.parent_first_name,
          parentLastName: detail.parent_last_name,
          email: detail.email,
          childName: detail.child_name,
          childLastName: detail.child_last_name,
          consentDate: detail.consent_date,
          questionValue: detail.question_value,
          provider: detail.provider,
          childClass: detail.class_name,
        });
      }
    }
    return parents;
  }

  noResponseParents(details) {
    const parents = [];

    for (const detail of details) {
      if (detail.question_value === -1) {
        // tslint:disable-next-line:max-line-length
        parents.push({
          parentId: detail.parent_id,
          parentFirstName: detail.parent_first_name,
          parentLastName: detail.parent_last_name,
          email: detail.email,
          childName: detail.child_name,
          childLastName: detail.child_last_name,
          consentDate: detail.consent_date,
          questionValue: detail.question_value,
          provider: detail.provider,
          childClass: detail.class_name,
        });
      }
    }
    return parents;
  }

  getChartMax(dataArray): number {
    return this.acceptedNumber + this.deniedNumber + this.noResponseNumber;
    // let max = 0;
    // for (const m of dataArray) {
    //   if (m > max) {
    //     max = m;
    //   }
    // }
    // return max;
  }
}
